var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-loading",style:(!_vm.$store.state.isShowShopping ? '':'opacity: 0')},[_c('div',{staticClass:"bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }